export default __webpack_public_path__ + "static/media/background-mob.9ae79408.mp4";